import React from "react";

import { Icon, type IconName } from "@orgmym/leeloo-core";
import { useTranslation } from "react-i18next";

import * as styles from "./media-menu.css";

export interface MediaMenuItem {
  id: string;
  icon: IconName;
  labelKey: string;
  testId: string;
  onClick?: () => void;
}

interface MediaMenuProps {
  items: MediaMenuItem[];
  onItemClick: (item: MediaMenuItem) => void;
  isMobile: boolean;
  isOpen: boolean;
  hasFocus?: boolean;
}

export const MediaMenu: React.FC<MediaMenuProps> = ({
  items,
  onItemClick,
  isMobile,
  isOpen,
  hasFocus = false
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const menuContent = (
    <>
      {items.map((item) => (
        <div
          key={item.id}
          className={styles.popoverMenuItem}
          data-testid={item.testId}
          onClick={() => onItemClick(item)}
        >
          <span className={styles.menuItemIcon}>
            <Icon name={item.icon} size="medium" />
          </span>
          <span>{t(item.labelKey)}</span>
        </div>
      ))}
    </>
  );

  if (isMobile) {
    return (
      <div
        className={`${styles.popoverMenu} ${
          hasFocus ? styles.popoverMenuWithKeyboard : ""
        }`}
        data-testid="message-menu-drawer"
      >
        {menuContent}
      </div>
    );
  }

  return (
    <div className={styles.popoverMenu} data-testid="message-menu-popover">
      {menuContent}
    </div>
  );
};

export default MediaMenu;
